import { type UserList, createUserList } from 'models';
import { useQuery } from 'query';
import { getUsers } from '../services';
import { useGetUsersParameters } from './hooks';
import { getUsersListQueryKey } from './keys';

type P = {
  excludeCommunityId?: string;
  excludeProgramId?: string;
  limit?: number;
  search?: string;
};

export const useUsersQuery = ({ excludeCommunityId, excludeProgramId, limit, search }: P) => {
  const getUsersParameters = useGetUsersParameters();

  return useQuery<UserList[]>({
    async queryFn() {
      const { data } = await getUsers({
        config: {
          params: getUsersParameters({
            filter: { excludeCommunityId, excludeProgramId, search },
            pagination: { limit },
          }),
        },
      });

      return data.map((user) => createUserList(user));
    },
    queryKey: getUsersListQueryKey({
      filter: { excludeCommunityId, excludeProgramId, search },
      pagination: { pageSize: limit },
    }),
  });
};
